import { LocationUpdateModal } from 'components/Location/LocationUpdateModal'
import { useBoolean } from 'hooks'
import { useState } from 'react'
import { Box } from 'theme-ui'
import { ViewMode } from 'types'
import { LocationCard } from '../LocationCard/LocationCard'

export type LocationListProps = {
  ids?: string[]
  viewMode?: ViewMode
  onRemoveLocation: (id: string) => void
}

export const LocationList = ({
  ids,
  viewMode = 'edit',
  onRemoveLocation,
}: LocationListProps) => {
  const [locationToUpdate, setLocation] = useState<string>('')
  const [
    showForm,
    openUpdateLocationModal,
    closeUpdateLocationModal,
  ] = useBoolean(false)
  const updateLocation = (id: string) => {
    setLocation(id)
    openUpdateLocationModal()
  }

  return ids ? (
    <>
      <LocationUpdateModal
        id={locationToUpdate}
        onLocationUpdated={closeUpdateLocationModal}
        handleCancel={closeUpdateLocationModal}
        show={showForm}
      />
      <Box className={'LocationList'}>
        {ids.map((id, idx) => (
          <Box key={id}>
            <h3>Location {idx + 1}</h3>
            <LocationCard
              locationId={id}
              viewMode={viewMode}
              onEditLocation={updateLocation}
              onRemoveLocation={onRemoveLocation}
            />
          </Box>
        ))}
      </Box>
    </>
  ) : null
}
